import {
    GET_EMISSION_FACTORS_FAIL,
    GET_EMISSION_FACTORS_SUCCESS,
    POST_EMISSION_FACTORS_FAIL,
    POST_EMISSION_FACTORS_SUCCESS,
    START_LOADING,
    START_POSTING,
    START_COMPANY_SUMMARY_LOADING,
    START_GROUP_SUMMARY_LOADING,
    START_COMPANY_SCOPE_ONE_LOADING,
    START_GROUP_SCOPE_ONE_LOADING,
    START_COMPANY_SCOPE_TWO_LOADING,
    START_GROUP_SCOPE_TWO_LOADING,
    START_COMPANY_SCOPE_THREE_LOADING,
    START_GROUP_SCOPE_THREE_LOADING,
    GET_COMPANY_EMISSIONS_SUMMARY_SUCCESS,
    GET_COMPANY_EMISSIONS_SUMMARY_FAIL,
    GET_COMPANY_EMISSIONS_SCOPE_ONE_SUCCESS,
    GET_COMPANY_EMISSIONS_SCOPE_ONE_FAIL,
    GET_COMPANY_EMISSIONS_SCOPE_TWO_SUCCESS,
    GET_COMPANY_EMISSIONS_SCOPE_TWO_FAIL,
    GET_COMPANY_EMISSIONS_SCOPE_THREE_SUCCESS,
    GET_COMPANY_EMISSIONS_SCOPE_THREE_FAIL,
    GET_GROUP_EMISSIONS_SUMMARY_SUCCESS,
    GET_GROUP_EMISSIONS_SUMMARY_FAIL,
    GET_GROUP_EMISSIONS_SCOPE_ONE_SUCCESS,
    GET_GROUP_EMISSIONS_SCOPE_ONE_FAIL,
    GET_GROUP_EMISSIONS_SCOPE_TWO_SUCCESS,
    GET_GROUP_EMISSIONS_SCOPE_TWO_FAIL,
    GET_GROUP_EMISSIONS_SCOPE_THREE_SUCCESS,
    GET_GROUP_EMISSIONS_SCOPE_THREE_FAIL,
    EXPORT_COMPANY_EMISSIONS_SUMMARY_SUCCESS,
    EXPORT_COMPANY_EMISSION_SUMMARY_FAIL,
    EXPORT_GROUP_EMISSIONS_SUMMARY_FAIL,
    EXPORT_GROUP_EMISSIONS_SUMMARY_SUCCESS
} from '../../../actions/carbonfootprint-rework/types/07-emission-factors';

const initialState = {
    loading: true,
    posting: false,
    companySummaryLoading: true,
    companyScopeOneLoading: false,
    companyScopeTwoLoading: true,
    companyScopeThreeLoading: false,
    groupSummaryLoading: true,
    groupScopeOneLoading: false,
    groupScopeTwoLoading: true,
    groupScopeThreeLoading: false,
    emissionFactors: [],
    companyEmissionsSummary: [],
    groupEmissionsSummary: [],
    companyEmissionsScopeOne: [],
    companyEmissionsScopeTwo: [],
    companyEmissionsScopeThree: [],
    groupEmissionsScopeOne: [],
    groupEmissionsScopeTwo: [],
    groupEmissionsScopeThree: [],
    companyEmissionsExport: [],
    groupEmissionsExport: [],
};

export default function emissionFactorsReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case START_LOADING:
            return {
                ...state,
                loading: true
            }
        case START_POSTING:
            return {
                ...state,
                posting: true
            }
        case GET_EMISSION_FACTORS_SUCCESS:
            return {
                ...state,
                emissionFactors: payload,
                loading: false
            }
        case GET_EMISSION_FACTORS_FAIL:
            return {
                ...state,
                emissionFactors: payload,
                loading: false
            }
        case POST_EMISSION_FACTORS_SUCCESS:
            return {
                ...state,
                posting: false
            }
        case POST_EMISSION_FACTORS_FAIL:
            return {
                ...state,
                posting: false
            }
        case START_COMPANY_SUMMARY_LOADING:
            return {
                ...state,
                companySummaryLoading: true
            }
        case START_COMPANY_SCOPE_ONE_LOADING:
            return {
                ...state,
                companyScopeOneLoading: true
            }
        case START_COMPANY_SCOPE_TWO_LOADING:
            return {
                ...state,
                companyScopeTwoLoading: true
            }
        case START_COMPANY_SCOPE_THREE_LOADING:
            return {
                ...state,
                companyScopeThreeLoading: true
            }
        case START_GROUP_SUMMARY_LOADING:
            return {
                ...state,
                groupSummaryLoading: true
            }
        case START_GROUP_SCOPE_ONE_LOADING:
            return {
                ...state,
                groupScopeOneLoading: true
            }
        case START_GROUP_SCOPE_TWO_LOADING:
            return {
                ...state,
                groupScopeTwoLoading: true
            }
        case START_GROUP_SCOPE_THREE_LOADING:
            return {
                ...state,
                groupScopeThreeLoading: true
            }
        case GET_COMPANY_EMISSIONS_SUMMARY_SUCCESS:
            return {
                ...state,
                companyEmissionsSummary: payload,
                companySummaryLoading: false
            }
        case GET_COMPANY_EMISSIONS_SUMMARY_FAIL:
            return {
                ...state,
                companyEmissionsSummary: payload,
                companySummaryLoading: false
            }
        case GET_COMPANY_EMISSIONS_SCOPE_ONE_SUCCESS:
            return {
                ...state,
                companyEmissionsScopeOne: payload,
                companyScopeOneLoading: false
            }
        case GET_COMPANY_EMISSIONS_SCOPE_ONE_FAIL:
            return {
                ...state,
                companyEmissionsScopeOne: payload,
                companyScopeOneLoading: false
            }
        case GET_COMPANY_EMISSIONS_SCOPE_TWO_SUCCESS:
            return {
                ...state,
                companyEmissionsScopeTwo: payload,
                companyScopeTwoLoading: false
            }
        case GET_COMPANY_EMISSIONS_SCOPE_TWO_FAIL:
            return {
                ...state,
                companyEmissionsScopeTwo: payload,
                companyScopeTwoLoading: false
            }
        case GET_COMPANY_EMISSIONS_SCOPE_THREE_SUCCESS:
            return {
                ...state,
                companyEmissionsScopeThree: payload,
                companyScopeThreeLoading: false
            }
        case GET_COMPANY_EMISSIONS_SCOPE_THREE_FAIL:
            return {
                ...state,
                companyEmissionsScopeThree: payload,
                companyScopeThreeLoading: false
            }
        case GET_GROUP_EMISSIONS_SUMMARY_SUCCESS:
            return {
                ...state,
                groupEmissionsSummary: payload,
                groupSummaryLoading: false
            }
        case GET_GROUP_EMISSIONS_SUMMARY_FAIL:
            return {
                ...state,
                groupEmissionsSummary: payload,
                groupSummaryLoading: false
            }
        case GET_GROUP_EMISSIONS_SCOPE_ONE_SUCCESS:
            return {
                ...state,
                groupEmissionsScopeOne: payload,
                groupScopeOneLoading: false
            }
        case GET_GROUP_EMISSIONS_SCOPE_ONE_FAIL:
            return {
                ...state,
                groupEmissionsScopeOne: payload,
                groupScopeOneLoading: false
            }
        case GET_GROUP_EMISSIONS_SCOPE_TWO_SUCCESS:
            return {
                ...state,
                groupEmissionsScopeTwo: payload,
                groupScopeTwoLoading: false
            }
        case GET_GROUP_EMISSIONS_SCOPE_TWO_FAIL:
            return {
                ...state,
                groupEmissionsScopeTwo: payload,
                groupScopeTwoLoading: false
            }
        case GET_GROUP_EMISSIONS_SCOPE_THREE_SUCCESS:
            return {
                ...state,
                groupEmissionsScopeThree: payload,
                groupScopeThreeLoading: false
            }
        case GET_GROUP_EMISSIONS_SCOPE_THREE_FAIL:
            return {
                ...state,
                groupEmissionsScopeThree: payload,
                groupScopeThreeLoading: false
            }
        case EXPORT_COMPANY_EMISSIONS_SUMMARY_SUCCESS:
            return {
                ...state,
                companyEmissionsExport: payload
            }
        case EXPORT_COMPANY_EMISSION_SUMMARY_FAIL:
            return {
                ...state,
                companyEmissionsExport: payload
            }
        case EXPORT_GROUP_EMISSIONS_SUMMARY_SUCCESS:
            return {
                ...state,
                groupEmissionsExport: payload
            }
        case EXPORT_GROUP_EMISSIONS_SUMMARY_FAIL:
            return {
                ...state,
                groupEmissionsExport: payload
            }
        default:
            return state;
    }
}